import { formatInteger } from '@brimo/shared';
import { FilterChip } from '../../../ds/components';
import type { ListResponse, PillKey } from '../types';
import styles from './list.module.css';

/** The filter pills of Finanzierungen 01/02 as the API sends them (label, count, active). */
export function FilterPills({
  pills,
  onSelect,
}: {
  pills: ListResponse['pills'];
  onSelect: (key: PillKey) => void;
}) {
  return (
    <div className={styles.pills} role="group" aria-label="Stufe filtern">
      {pills.map((pill) => (
        <FilterChip
          key={pill.key}
          label={pill.label}
          count={formatInteger(pill.count)}
          active={pill.active}
          onClick={() => onSelect(pill.key)}
        />
      ))}
    </div>
  );
}
